import React, { useRef } from 'react';
var VeltData = function (props) {
    var path = props.path, field = props.field, className = props.className, id = props.id;
    var ref = useRef();
    return (React.createElement("velt-data", { ref: ref, path: path, field: field, class: className, id: id }));
};
export default VeltData;
